import { SVGProps } from "react"

type Props = SVGProps<SVGSVGElement> & {
  size?: number
}

export const IconStitching = ({ size = 24, ...props }: Props) => (
  <svg
    id="stitching_svg__Calque_1"
    xmlns="http://www.w3.org/2000/svg"
    x={0}
    y={0}
    viewBox="0 0 44 44"
    xmlSpace="preserve"
    width={size}
    height={size}
    {...props}
  >
    <style>
      {
        ".stitching_svg__st0{fill:none;stroke:currentColor;stroke-width:2}.stitching_svg__st1{fill:currentColor}"
      }
    </style>
    <path className="stitching_svg__st0" d="M24.8 13.7h-8" />
    <path
      className="stitching_svg__st1"
      d="M5.8 33.6v-1.2H4.6v1.2h1.2zM10 21.7c0 .6.5 1.2 1.2 1.2.6 0 1.2-.5 1.2-1.2H10zm29.6 11.9V10.4h-2.3v23.2h2.3zm-35-21.3v3.8H7v-3.8H4.6zm2.3 6.1h8.4V16H6.9v2.4zM37.3 8.1H16.5v2.3h20.8V8.1zm-20.8 0H8.8v2.3h7.7V8.1zm1.1 8V9.3h-2.3v6.8h2.3zm19.6 17.5v2.7h2.3v-2.7h-2.3zm.1 2.7H8v2.3h29.3v-2.3zM7 35.2v-1.6H4.6v1.6H7zm-1.2-.4h32.6v-2.3H5.8v2.3zM10 17.5v4.1h2.3v-4.1H10zM8 36.3c-.6 0-1.1-.5-1.1-1.1H4.6c0 1.9 1.5 3.4 3.4 3.4v-2.3zm7.4-17.9c1.3 0 2.3-1 2.3-2.3h-2.3v2.3zM4.6 16.1c0 1.3 1 2.3 2.3 2.3V16H4.6zM7 12.3c0-1 .8-1.8 1.8-1.8V8.1c-2.3 0-4.2 1.9-4.2 4.2H7zm30.2 24.1c0-.1.1-.1 0 0v2.3c1.3 0 2.3-1 2.3-2.3h-2.3zm2.4-26c0-1.3-1-2.3-2.3-2.3v2.3h2.3z"
    />
    <path
      className="stitching_svg__st1"
      d="M36.6 5.7c0-.6-.5-1.2-1.2-1.2-.6 0-1.2.5-1.2 1.2h2.4zm0 3.1V5.7h-2.3v3.1h2.3z"
    />
    <path
      className="stitching_svg__st0"
      d="M5.8 32.4v-2.8c0-.6.5-1.1 1.1-1.1h17.7c.6 0 1.1-.5 1.1-1.1V9.5"
    />
    <circle className="stitching_svg__st0" cx={32} cy={26.2} r={3} />
  </svg>
)
